import angular from 'angular';
import { createEpicsService } from './utils';

// Import epics
import { reduxUIRouterEpic } from '@updater/ulytics';
import { epic as AnalyticsEpic } from './analytics';
import { epic as ErrorEpic } from './error';
import { epic as RouterEpic } from './router';
import { epic as SessionEpic } from './session';
import { epic as NextStepEpic } from './step';
import { epic as UserEpic } from './user';
import { epic as PromotionsEpic } from './promotions';
import { epic as ContentfulEpic } from './contentful';
import { epic as HomeServicesEpic } from './home-services';
import { epic as EventTrackerEpic } from './event-tracker';
import { epic as ExperimentsEpic } from './experiments';
import { epic as MoveIqEpic } from './moveiq';
import { epic as InsuranceEpic } from './insurance';
import { epic as AppShellEpic } from './app-shell';

const EpicsService = createEpicsService([
  // Order matters here
  reduxUIRouterEpic,
  RouterEpic,
  SessionEpic,
  NextStepEpic,
  UserEpic,
  ErrorEpic,
  AnalyticsEpic,
  PromotionsEpic,
  ContentfulEpic,
  HomeServicesEpic,
  EventTrackerEpic,
  ExperimentsEpic,
  MoveIqEpic,
  InsuranceEpic,
  AppShellEpic,
]);

export const EPICS_SERVICE = 'EpicsService';
export const EpicsModule = angular
  .module('app.state.epic', [])
  .service(EPICS_SERVICE, EpicsService);
